import React from "react";
import { Col } from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";

const ScriptsTitle = ({ t }) => {
  return (
    <Col md="12" xs="9">
      <h5 className="font-size-15 mt-2 text-wrap pl-0 d-flex">
        <i
          className="bx bx-copy-alt font-size-18 mr-1 text-muted "
          id="scripts"
        ></i>
        {t("Scripts")}
      </h5>
    </Col>
  );
};
export default withTranslation()(ScriptsTitle);
